import { Box, Grid, Tab } from '@mui/material';
import { useState } from 'react';
import { StyledTabs } from '../../../common/StyledComponents';
import ApplicationRestrictions from '../ApplicationRestrictions';
import GeneralApplicationSettings from '../GeneralApplicationSettings';

export const ApplicationSettingsTab = () => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    return (
        <div>
            <Grid item xs={9} sx={{ paddingLeft: '10px' }} >
                <StyledTabs
                    value={tabIndex}
                    onChange={(e, idx) => handleTabChange(idx)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="General" />
                    <Tab label="Application restrictions" />
                </StyledTabs>
            </Grid>
            <Box p={2} mt={4}>
                {tabIndex === 0 && (
                    <GeneralApplicationSettings />
                )}
                {tabIndex === 1 && (
                    <ApplicationRestrictions />
                )}
            </Box>
        </div>
    );
};
